import * as C from "@components";
import {VimeoBackground} from "@/components/Video/VimeoBackground";
import Link from "next/link";

interface AnnouncementSnaptixMouthpieceProps {
    isPageXL?: boolean;
    className?: string;
}

const imageDirectory = "/images/products/cartridges/active-snaptix-mouthpiece/";

export const AnnouncementSnaptixMouthpiece = ({ isPageXL = false, className }: AnnouncementSnaptixMouthpieceProps) => {
    return (
        <C.Card className={`relative min-h-[500px] md:min-h-[340px] mb-6 ${className ?? ''}`}>
            <div className="relative max-w-full md:max-w-[50%] h-full z-[23] text-center pt-4 lg:pt-12">
                <p className='tracking-widest text-[14px] font-semibold mb-4'>FEATURED</p>
                <h3 className='mb-4'>Snaptix Mouthpiece</h3>
                <div className='font-semibold text-3xl mb-4'>
                    <p>Pop open to puff.</p>
                    <p>Click closed to protect.</p>
                </div>
                <Link href="/snaptix-mouthpiece" className="btn-arrow-orange">
                    <span>Take a look</span>
                </Link>
                <p className='mt-12 mb-4'>Custom only, MOQ 5,000 units.</p>
            </div>
            <div className='hidden md:block h-full'>
                <VimeoBackground
                    videoId={isPageXL ? 1088872371 : 1088872355}
                    unlistedPrivacyHash={isPageXL ? '600d36a360' : '02d7322427'}
                    isVideoUnlisted
                    imageDirectory={imageDirectory}
                    needsThumbnail
                    thumbnailName={isPageXL ? 'snaptix-xl-banner-thumbnail.jpg' : 'snaptix-banner-thumbnail.jpg'}
                    needsRescaling
                />
            </div>
            <div className='block md:hidden h-full'>
                <VimeoBackground
                    videoId={1089130922}
                    unlistedPrivacyHash={'d291bf0de9'}
                    className='max-md:bottom-0'
                    isVideoUnlisted
                    imageDirectory={imageDirectory}
                    needsThumbnail
                    thumbnailName='snaptix-new-release-thumbnail.jpg'
                />
            </div>
        </C.Card>
    );
};
